import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { reasonsData } from "../../_helpers/reasons-data";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export const WhyUs = () => {
    return (
        <div className="reasons-container flx-col">
            <div className="reason-box">
                <div className="reason-cap">
                    <div className="reason-txt blk">Warum</div>
                    <div className="reason-txt sec-col">Wir?</div>
                </div>
                <div className="flx-col why-us-list">
                    {reasonsData.map((reason) => (
                        <div className="flx-rw c-al reason-unit">
                            <FontAwesomeIcon icon={faCheckCircle} className="circle-check" />
                            <span className="reason-box-text">{reason}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}